import { Injectable } from '@angular/core';
import { Params, Router } from '@angular/router';
import { OrganizationInfosGuardianMinionService } from './organization-infos-guardian-minion.service';
import { OrganizationInfos } from './organization.dto';
import { DivisionService } from './division.service';
import { DivisionGuardService } from './division-guard.service';

@Injectable()
export class DivisionGuardianMinionService extends OrganizationInfosGuardianMinionService<OrganizationInfos> {
  constructor(
    private readonly divisionService: DivisionService,
    protected readonly router: Router,
    protected readonly authService: DivisionGuardService,
  ) {
    super(router, authService);
  }

  async resolveTargetDto(params: Params): Promise<OrganizationInfos> {
    const division = await this.divisionService.getById(params['division']);
    return { division, organization: division.organization, enabled: !!division.enabled };
  }
}
